export { ProposalInflowsSectionContainer } from './ProposalInflowsSectionContainer';
export { ProposalInflowsSection } from './ProposalInflowsSection';
